import React from "react";

/** One block of the Ads Settings tab: icon, title, one-line description, optional header action. */
const AdsSectionCard = ({ icon: Icon, iconClass = "bg-blue-50 text-blue-600", title, description, action, children }) => (
  <section className="bg-white rounded-xl shadow-sm border border-gray-100 overflow-hidden">
    <header className="px-5 py-4 border-b border-gray-100 flex flex-wrap items-start justify-between gap-3">
      <div className="flex items-start gap-3 min-w-0">
        {Icon && (
          <div className={`w-9 h-9 rounded-lg flex items-center justify-center shrink-0 ${iconClass}`}>
            <Icon size={17} />
          </div>
        )}
        <div className="min-w-0">
          <h3 className="text-sm font-semibold text-gray-800">{title}</h3>
          {description && <div className="text-xs text-gray-500 mt-0.5">{description}</div>}
        </div>
      </div>
      {action}
    </header>
    {children}
  </section>
);

/** The on/off switch used across the tab. `label` is its accessible name. */
export const Switch = ({ checked, onChange, label, disabled }) => (
  <button
    type="button"
    role="switch"
    aria-checked={!!checked}
    aria-label={label}
    disabled={disabled}
    onClick={onChange}
    className={`relative inline-flex h-6 w-11 shrink-0 items-center rounded-full transition-colors focus:outline-none focus-visible:ring-2 focus-visible:ring-blue-300 disabled:opacity-60 disabled:cursor-not-allowed ${
      checked ? "bg-blue-600" : "bg-gray-200"
    }`}
  >
    <span
      className={`inline-block h-4 w-4 transform rounded-full bg-white shadow transition-transform ${
        checked ? "translate-x-6" : "translate-x-1"
      }`}
    />
  </button>
);

export const Spinner = () => (
  <div className="flex justify-center items-center py-10">
    <div className="w-6 h-6 border-4 border-blue-400 border-t-transparent rounded-full animate-spin" />
  </div>
);

export default AdsSectionCard;
